module.exports = "./assets/assets/抽取流程.738726cb.docx";